<template>
    <div class="modal-bg">
        <div class="circle-pop">
            <div>
                <p class="circle-pop-title text-average text-bold">
                    {{ conteudo[selecionado].tituloDisplay }}
                </p>
                <p
                    class="circle-pop-texto p2"
                    v-html="conteudo[selecionado].texto"
                ></p>
                <button class="circle-pop-btn" @click="fechaModal">OK</button>
            </div>
        </div>
    </div>
</template>
<script>
import { imagePath } from "../mixins/imagePath.js";

export default {
    props: ["conteudo", "selecionado"],
    mixins: [imagePath],
    methods: {
        fechaModal() {
            this.$emit("fechaModal");
        },
    },
};
</script>
<style lang="scss" scoped>
.circle {
    &-icon {
        display: flex;
        align-self: flex-start;
        margin-bottom: auto;
    }
    &-pop {
        margin-top: 100px;
        display: flex;
        flex-direction: row;
        align-items: center;
        text-align: left;
        position: absolute;
        top: 25%;
        right: 90px;
        max-width: 600px;
        padding-left: 20px;

        h1 {
            text-align: left;
            font-weight: bold;
            // color: black;
            //padding-left: 20px;
            padding-bottom: 20px;
        }
        &-texto {
            //padding: 0px 20px 20px 20px;
            max-height: 310px;
        }
        &-btn {
            display: none;
            position: absolute;
            bottom: 10px;
            left: 50%;
            transform: translateX(-50%);
            border: 0px;
            color: white;
            font-size: 1.2rem;
            font-weight: bold;
            border-radius: 56px;
            width: 250px;
            height: 30px;
            text-align: center;
            background-color: $color-cerulean;

            cursor: pointer;
            user-select: none;
        }
        &-btn:hover {
            color: white;
            transition: 0.4s;
            background-color: $color-yellow;

            cursor: pointer;
            user-select: none;
        }
    }
}
@media (max-width: 1332px) {
    .circle {
        &-icon {
            display: flex;
            //align-self: center;
            align-self: flex-start;
            margin-bottom: 20px;
            img {
                min-width: 110px;
            }
        }
        &-pop {
            margin-top: 0;
            text-align: left;
            background-color: white;
            position: absolute;
            top: 30%;
            right: 10px;
            width: 38%;
            max-width: auto;
            border-radius: 10px;
        }
    }
}
@media (max-width: 1100px) {
    .modal-bg {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background-color: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100vh;
    }
    .circle {
        &-pop {
            padding: 20px;
            flex-direction: column;
            text-align: left;
            background-color: white;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            max-width: 90%;
            width: 90%;
            border-radius: 10px;

            h1 {
                text-align: left;
                font-weight: bold;
                color: black;
                padding-left: 20px;
            }
            &-texto,
            &-title {
                padding: 0px 20px 20px 20px;
                // overflow-y: scroll;
            }
            &-btn {
                display: block;
                position: relative;
            }
        }
        &-icon {
            display: flex;
            align-self: center;
            justify-content: center;
            min-width: 100%;
            margin-bottom: 20px;
            img {
                min-width: 70px;
                min-height: 70px;
            }
        }
    }
    @media (max-width: 330px) {
        .circle {
            &-pop {
                padding: 20px;
                flex-direction: column;
                text-align: left;
                background-color: white;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                max-width: 80%;
            }
        }
    }
}
</style>